import React from "react";

const index = () => {
  return (
    <footer className="custom_footer">
      <div className="footer_content">
        <h3 className="title_text">Bhagirath Sheela</h3>
        <p className="content_text">
          Hi, I'm Bhagirath Sheela, a front-end developer with a passion for web
          and native app development. I have 5 years of experience in web
          development, and I specialize in HTML, CSS, JavaScript and ReactJS.
          Below is my contact details please get in touch in case of any query
        </p>
        <p className="content_text">
          <span className="text_strong">Email : </span>
          <span>bhagirathsheela001@gmail.com</span>
        </p>
        <p className="content_text">
          <span className="text_strong">Mobile No. : </span>
          <span>+91 96109 28997</span>
        </p>
        <ul className="social_media_icons_wrap">
          <li>
            <a
              className="btn_social twitter_btn"
              href="https://twitter.com/BHAGIRATHSHEELA"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1.25em"
                viewBox="0 0 512 512"
              >
                <style dangerouslySetInnerHTML={{ __html: "svg{fill:#ccc}" }} />
                <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
              </svg>
            </a>
          </li>
          <li>
            <a
              className="btn_social facebook_btn"
              href="https://www.facebook.com/bhagirath.sheela.54/"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1.25em"
                viewBox="0 0 320 512"
              >
                <style dangerouslySetInnerHTML={{ __html: "svg{fill:#ccc}" }} />
                <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
              </svg>
            </a>
          </li>
          <li>
            <a
              className="btn_social youtube_btn"
              href="https://www.youtube.com/@trekkit5911"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1.25em"
                viewBox="0 0 576 512"
              >
                <style dangerouslySetInnerHTML={{ __html: "svg{fill:#ccc}" }} />
                <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
              </svg>
            </a>
          </li>
          <li>
            <a
              className="btn_social linkedin_btn"
              href="https://www.linkedin.com/in/bhagirath-sheela-a240b7b3/"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1.25em"
                viewBox="0 0 448 512"
              >
                <style dangerouslySetInnerHTML={{ __html: "svg{fill:#ccc}" }} />
                <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
              </svg>
            </a>
          </li>
        </ul>
      </div>
      <div className="footer_bottom">
        <p className="copy_right_text">
          © {new Date().getFullYear()} <a href="/">Bhagirath Sheela</a>
        </p>

        <p className="privacy_policy_text">
          <a href="/privacy-policy">Privacy Policy</a>
        </p>
      </div>
    </footer>
  );
};

export default index;
